import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  container: {
    margin: '0 48px',
    [theme.breakpoints.down('md')]: {
      margin: 'unset',
    },
  },
  filterPillsWrapper: {
    alignSelf: 'center',
  },
  mobileFilters: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  desktopFilters: {
    display: 'block',
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));
